import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import { responseSelector } from "../utils/helpers/selectors";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";
import PYG from "../utils/PYG";

const { Text } = Inputs;

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];

const tipoOptions = () => [
  { value: "m", label: "Meses" },
  { value: "d", label: "Dias" },
  { value: "w", label: "Semanas" },
];

function AddPlan({ history, match }) {
  const dispatch = useDispatch();

  const modelCreatePlan = useSelector((state) => state.createPlan);

  const [descripcion, setDescripcion] = useState("");
  const [precio, setPrecio] = useState(0);
  const [estado, setEstado] = useState("ACTIVO");
  const [groupLabel, setGroupLabel] = useState("reservas");
  const [duracion, setDuracion] = useState("1");
  const [tipoDuracion, setTipoDuracion] = useState("m");
  const [capacidad, setCapacidad] = useState(5);

  useEffect(() => {
    const { data, error } = responseSelector(modelCreatePlan);

    if (error) {
      alert(error);
      dispatch(controller.createPlanDuck.actions.clear());
    }
    if (data) {
      history.push(`/planes/${match.params.localId}`);
      dispatch(controller.createPlanDuck.actions.clear());
    }
  }, [modelCreatePlan]);

  function submit() {
    if (
      !descripcion ||
      !tipoDuracion ||
      !estado ||
      precio === "" ||
      precio === null ||
      !duracion ||
      !capacidad
    ) {
      alert("Por favor complete todos los campos");
      return;
    }

    let path = descripcion.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    path = path.replace(/[^a-zA-Z ]/g, "");
    path = path.replace(/\s/g, "");

    const label = `/` + path.toLowerCase();

    let data = {
      localId: match.params.localId,
      label: label,
      descripcion,
      estado,
      precio,
      groupLabel: "reservas",
      duracion: duracion,
      tipoDuracion,
      capacidad: capacidad,
    };

    dispatch(controller.createPlanThunk(data));
  }
  return (
    <Content title="Nuevo plan" browserTitle="Nuevo plan" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Nuevo plan"
            footer={
              <>
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.push(`/planes/${match.params.localId}`);
                  }}
                />

                <Button
                  type="primary"
                  text="Guardar"
                  pullRight={true}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />

            <SelectInput
              value={estado}
              setValue={setEstado}
              label={<Etiqueta texto="Estado" obligatorio={true} />}
              options={estadoOptions()}
            />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              value={descripcion}
              onChange={(evt) => setDescripcion(evt.target.value)}
            />

            <PYG
              // react-number-format's props
              value={precio}
              isNumericString={true}
              displayType="input"
              onValueChange={(values) => {
                const { formattedValue, value } = values;
                setPrecio(value);
              }}
              decimalScale={0}
              customInput={Text}
              // adminlte-2-react's Text's props
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Precio" obligatorio={true} />}
            />

            <Text
              inputType="number"
              labelPosition="above"
              size="sm"
              label={
                <Etiqueta
                  texto="Sesiones (reservas incluidas)"
                  obligatorio={true}
                />
              }
              value={capacidad}
              onChange={(evt) => setCapacidad(evt.target.value)}
            />

            <SelectInput
              value={tipoDuracion}
              setValue={setTipoDuracion}
              label={<Etiqueta texto="Tipo duración" obligatorio={true} />}
              options={tipoOptions()}
            />

            <Text
              inputType="number"
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Duración" obligatorio={true} />}
              value={duracion}
              onChange={(evt) => setDuracion(evt.target.value)}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AddPlan;
